export function isWebAddressLike(value) {
    return /^(https?:\/\/)?[\p{L}\p{N}][\p{L}\p{N}-]*(\.[\p{L}\p{N}-]+)*\.[a-z0-9]+($|\/|:\d+|\?|#)/iu.test(value);
}
